import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import sharingDetails from "./sharingDetails.module";
import IdentifierDetails from "./IdentifierDetails.module";
import setURL from "./setURL.module";
import AccounType from "./AccounType.module";
import undoneRefundDetails from "./undoneRefundDetails.module";
import getBankList from "./getBankList.module"
import getNotification from "./getNotification.module"
import interBankPayment from "./interBankPayment.module"
import getBalance from "./getBalance.module";
import getCountCustomer from "./getCountCustomer.module";
import getCreditors from "./getCreditors.module";
import getMonthlyReport from "./getMonthlyReport.module";
import getUserList from "./getUserList.module";
import requestHandler from "./requestHandler.module";
import getRoles from "./getRoles.module";
import internalTransfer from "./internalTransfer.module";
import updateUserCard from "./updateUserCard.module";
import updateUserConf from "./updateUserConf.module";
import refundManualCharge from "./refundManualCharge.module";
import DepositWithId from "./DepositWithId.module";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        htmlClass,
        config,
        breadcrumbs,
        sharingDetails,
        setURL,
        AccounType,
        IdentifierDetails,
        undoneRefundDetails,
        getBankList,
        interBankPayment,
        getNotification,
        getBalance,
        getCountCustomer,
        getCreditors,
        getMonthlyReport,
        getUserList,
        requestHandler,
        getRoles,
        internalTransfer,
        updateUserCard,
        updateUserConf,
        refundManualCharge,
        DepositWithId
    }
});